import React from "react";
import { PortableText } from "@portabletext/react";

const TextArea = (props) => (
	<div className={props.customClass ?? "hd-screen-max-width md:px-10 lg:px-20 p-5 break-words  pt-10 text-left mx-auto"}>
		<PortableText value={props.value ?? props.data?.data} />
	</div>
);

export default TextArea;
